import { Modal } from 'react-bootstrap'
import React from 'react'
import Select from 'react-select'
import DatePicker from 'react-multi-date-picker'
import Toolbar from 'react-multi-date-picker/plugins/toolbar'
import dayjs from '../../utils/dayjsConfig'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'
import { ASSIGN_STATUS_TYPES_DIC, DATE_PICKER_SETTINGS } from '../constants/constants'

const AssignDocumentsModal = ({
  selectedDocuments,
  deliverymen,
  selectedDeliveryman,
  setSelectedDeliveryman,
  setSelectedDeliverymanLabel,
  selectedVisitDate,
  setSelectedVisitDate,
  areAllModalInputsFull,
  showModal,
  closeModal,
  saving
}) => {
  const selectedDocumentsToAssign = selectedDocuments?.filter(
    (doc) => doc.status === ASSIGN_STATUS_TYPES_DIC.TO_BE_ASSIGNED
  ).length
  const selectedDocumentsToReassign = selectedDocuments?.filter(
    (doc) => doc.status === ASSIGN_STATUS_TYPES_DIC.OPEN
  ).length

  const handleConfirm = () => {
    closeModal(true)
  }

  const deleteSelectionOption = {
    label: '- REMOVER ASIGNACIÓN -',
    value: 'remove_assignment'
  }

  const customDeliverymenOptions = [
    ...(selectedDocumentsToReassign > 0 ? [deleteSelectionOption] : []),
    ...deliverymen
  ]

  const handleCancel = () => {
    if (!saving) {
      closeModal(false)
    }
  }

  const handleDeliverymanSelection = (option) => {
    setSelectedDeliveryman(option?.value || null)
    setSelectedDeliverymanLabel(option?.label || null)
  }

  const handleDateFilter = (dateObj) => {
    if (!dateObj || dateObj.length === 0) {
      return
    }
    const formatedDate = dayjs.unix(dateObj.unix)
    const visitDate = dayjs.min(formatedDate).startOf('day').format('YYYY-MM-DD')
    setSelectedVisitDate(visitDate)
  }

  const disableDatepicker = () => {
    if (selectedDeliveryman === 'remove_assignment') {
      setSelectedVisitDate(null)
      return true
    }
    return false
  }

  return (
    <div>
      <Modal
        onHide={handleCancel}
        backdrop="static"
        keyboard={false}
        size="lg"
        show={showModal}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <p className="title-grey-icon ">
              <b className="unavailable-modal-title"> Asignar documentos</b>
            </p>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: '20px' }}>
          <div>
            <div className="container-fluid modal-container">
              <div className="form-row">
                <p>
                  Selecciona un entregador y una fecha para asignar los documentos seleccionados.
                </p>
              </div>
              <div className="mb-20 assign-modal-info-flex">
                {selectedDocumentsToAssign > 0 && (
                  <div className="assign-modal-info-flex">
                    <span className="assign-document-modal-bold">
                      Documentos seleccionados para asignar:
                    </span>
                    <span className="assign-modal-number">{selectedDocumentsToAssign}</span>
                  </div>
                )}
                {selectedDocumentsToReassign > 0 && (
                  <div className="assign-modal-info-flex">
                    <span className=" assign-document-modal-bold">
                      Documentos seleccionados por re-asignar:
                    </span>
                    <span className="reassign-modal-number">{selectedDocumentsToReassign}</span>
                  </div>
                )}
              </div>
              <div className="form-row">
                <p>
                  <span className="mb-20 assign-document-modal-bold">
                    1. Escoja a un entregador:
                  </span>
                </p>
                <Select
                  options={customDeliverymenOptions}
                  noOptionsMessage={() => 'No hay resultados'}
                  className="mb-16"
                  placeholder={'Busque o seleccione una opción'}
                  isSearchable={true}
                  onChange={handleDeliverymanSelection}
                />
              </div>

              <div className="form-row">
                <p>
                  <span className="mb-20 assign-document-modal-bold">
                    2. Asigne fecha de la visita:
                  </span>
                </p>
                <DatePicker
                  disabled={disableDatepicker()}
                  months={DATE_PICKER_SETTINGS.months}
                  weekDays={DATE_PICKER_SETTINGS.weekDays}
                  format="DD/MM/YYYY"
                  weekStartDayIndex={DATE_PICKER_SETTINGS.weekStartDayIndex}
                  highlightToday={false}
                  numberOfMonths={1}
                  minDate={dayjs().local().startOf('day').toDate()}
                  onChange={(dateObjects) => {
                    handleDateFilter(dateObjects)
                  }}
                  plugins={[
                    <Toolbar
                      position="bottom"
                      names={{
                        today: 'Hoy'
                      }}
                      sort={['today']}
                    />
                  ]}
                  render={(value, openCalendar) => {
                    return (
                      <div
                        key={`flr-date`}
                        className={`${disableDatepicker() ? 'react-filter-disabled' : ''}`}
                      >
                        <div className="react-filter-box assign-doc-modal-datepicker-width">
                          <div
                            title="Fecha de día de visita"
                            onClick={!disableDatepicker() ? openCalendar : undefined}
                            className="react-filter-box-clickable-zone mb-16"
                          >
                            <div className="react-filter-titles">
                              {value?.length > 0 && (
                                <>
                                  {Array.isArray(value) ? (
                                    <div className="filter-title-overflow">{value.join(' - ')}</div>
                                  ) : (
                                    <div className="filter-title-overflow">{value}</div>
                                  )}
                                  <FontAwesomeIcon
                                    className={`${disableDatepicker() ? 'color-calendar-disabled' : 'color-calendar-active'}`}
                                    icon={faCalendar}
                                  />
                                </>
                              )}
                              {value?.length == 0 && (
                                <>
                                  <div className="filter-title-overflow">DD/MM/YYYY</div>
                                  <FontAwesomeIcon
                                    className={`${disableDatepicker() ? 'color-calendar-disabled' : 'color-calendar-active'}`}
                                    icon={faCalendar}
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }}
                />
              </div>
              <br />
              <div className="form-group">
                <div className="check-modal-user d-flex align-items-center"></div>
                <div className="float-right mt-3">
                  <button
                    onClick={handleCancel}
                    className="btn cancel-modal-button"
                    disabled={saving}
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleConfirm}
                    className={`btn float-right ${areAllModalInputsFull() ? 'blue-modal-button' : 'blue-disabled-modal-button'}`}
                    disabled={!areAllModalInputsFull() || saving}
                  >
                    {saving ? 'Asignando...' : 'Confirmar y asignar'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default AssignDocumentsModal
